<template>
  <div>
    <p class="text-lg">Customer Invoice Data</p>
    <hr />

    <div class="my-2">
      <label class="vs-input--label">Customer Invoice ID</label>
      <CustomerInvoice
        @data="setCustomerInvoice"
        :isDisable="isDisabled"
        :isFullReturn="isFullReturn"
        ref="searchCustomerInvoice"
      />
    </div>
    <div class="my-2">
      <label class="vs-input--label">Sales ID</label>
      <vs-input readonly class="w-full" v-model="sales_name" />
    </div>

    <!-- Komponen bayangan -->
    <SelectCustomerAddress
      v-if="false"
      ref="selectCustomerAddress"
      :isDisabled="
        form.so_types == 'with_so_reference' ||
        form.isDetail == 1 ||
        form.isEdit
      "
      :formDatas="form"
    />
  </div>
</template>

<script>
import CustomerInvoice from "@/components/master/CustomerInvoice.vue";
import { RepositoryFactory } from "@/repositories/repositoryFactory";
import { watch } from "vue";
const MasterRepository = RepositoryFactory.get("master");
// DTO customer invoice
var dtoCustomerInvoice = {
  invoiceID: null,
  salesID: null,
  customerIDs: [],
  itemUnitIDs: [],
  skuHU: [],
  salesOrderLines: [],
  combo_master: [],
  salesOrderID: null,
  salesOrderData: null,
};

// set dto customer invoice
function setDtoCustomerInvoice(data) {
  console.log("setDtoCustomerInvoice", data)
  if(data!=null){
    dtoCustomerInvoice.invoiceID = data.invoice.ID;
    dtoCustomerInvoice.salesID = data.sales.ID;
    dtoCustomerInvoice.customerIDs = [data.invoice.ClientID];
    dtoCustomerInvoice.invoice = data.invoice;
    dtoCustomerInvoice.skuHU = data.sku_hu;
    dtoCustomerInvoice.combo_master = data.combo_master;
    // dtoCustomerInvoice.itemUnitIDs = data.item_unit_ids;
  
    // sales_order -> sales_order_lines
    dtoCustomerInvoice.invoiceLines = [];
    data.invoice.InvoiceLines.forEach((item2) => {
      dtoCustomerInvoice.invoiceLines.push(item2);
    });
  
    if (data.sales_order.length > 0) {
      dtoCustomerInvoice.salesOrderID = data.sales_order[0].ID;
      dtoCustomerInvoice.salesOrderData = data.sales_order[0];
    } else {
      dtoCustomerInvoice.salesOrderID = 0;
      dtoCustomerInvoice.salesOrderData = null;
    }
  
    return dtoCustomerInvoice;
  } else {
    return null
  }
}

export default {
  components: {
    CustomerInvoice,
  },
  props: {
    isDisabled: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      required: false,
    },
    returnTypeStr: {
      type: String,
      default: "1",
    },
  },
  data() {
    return {
      sales_name: null,
      data: {
        sales: null,
        invoice: null,
        sales_order: [],
      },
      isFullReturn: true,
    };
  },
  methods: {
    async setCustomerInvoice(data) {
      // Cek Shipto First CR-2600053
      console.log("Cek Shipto First", data);
      console.log("this.form", this.form);
      let res = await this.getShipto({
        params: {
          id: data.invoice.ShipmentToAddressID,
          so_type: this.form.so_types,
          is_create: (this.form.isDetail != 1 && !this.form.isEdit),
          is_default: true,
        },
      });
      console.log("res", res);
      
      let allowShipto = this.checkShipto(res);
      if(!allowShipto){
        this.data = {
          sales: null,
          invoice: null,
          sales_order: [],
        };
        return;
      } else {
        this.data = data;
        // console.log("this.data", this.data)
        this.sales_name = (data.sales_order.length > 0 && data.sales_order != null) ? `${data.sales_order[0].SalesPersonalCodeExternal} - ${data.sales_order[0].SalesPersonalName}` : `${data.sales.CodeExternal} - ${data.sales.Name}`;
        this.$emit("data", setDtoCustomerInvoice(data));
      }
    },
    setNullInvoiceData(fullReset){
      //set null all data
      console.log("Set null invoice data", fullReset);
      if (fullReset) {
        this.$refs.searchCustomerInvoice.setCode(
          null
        );
      }
      this.form.customer_invoice_data = {
        customer_invoice_id: null,
        sales_id: null,
        item_unit_ids: [],
        sales_order_lines: [],
        sales_order_id: null,
        invoice_lines: [],
        invoice_id: null,
        sales_order_data: null,
      };
      this.form.customer_return_data.customer_ship_to = null;
      this.form.territory_warehouse = null;
      this.form.territory_warehouse_id = null;
      this.sales_name = null;
      this.data       = {
        sales: null,
        invoice: null,
        sales_order: [],
      };
    },
    async getShipto(params){
      try {
        const result = await MasterRepository.getCustomerAddressShipToSr(params);
        let resp = result;
        console.log("result", result);
        console.log("resp", resp);
        if (result.code == 200 && result.data.records.length > 0) {
          return result.data.records
        } else if (result.code == 200 && result.data.records.length == 0) {
          this.$vs.notify({
            title: "Error",
            text: "Shipto not found!",
            color: "danger",
            iconPack: "feather",
            icon: "icon-x-circle",
          });  
        } else {
          console.log("Error resp", resp);
          this.$vs.notify({
            title: "Error",
            text: resp.message,
            color: "danger",
            iconPack: "feather",
            icon: "icon-x-circle",
          });  
        }
      } catch (error) {
        this.$vs.notify({
          title: "Error",
          text: "Error while fetching customer address ship to",
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-circle",
        });
        console.log("Error while fetching customer address ship to", error);
      }
    },
    checkShipto(resSelected){
      // CR-2600053_Cek Config Allow Return
      let msg = "", allowShipto = false;
      if(resSelected[0].cust_category.allow_return != null && resSelected[0].cust_category.allow_return == false){
        // OLD msg = "Cannot using invoice shipto for all return type!<br> Customer Category "+resSelected[0].cust_category.name+" Allow Return False!",
        msg = "Customer "+ resSelected[0].cust_category.name +" not allowed return."
        this.$vs.notify({
          title: "Error",
          text: msg,
          color: "danger",
          iconPack: "feather",
          icon: "icon-x-circle",
        });
        return allowShipto;
      } else {
        // Cek Cg 1 2 3
        let cg1 = null, cg2 = null, cg3 = null
        cg1 = resSelected[0].cust_group_1.sr_without_ref;
        cg2 = resSelected[0].cust_group_2.sr_without_ref;
        cg3 = resSelected[0].cust_group_3.sr_without_ref;

        console.log("cg1, 2, 3", cg1, cg2, cg3)
        if(cg1 && cg2 && cg3){
          if(this.form.so_types == 'with_so_reference' && this.form.isDetail != 1 && !this.form.isEdit ){
            allowShipto = true;
          }
        } else {
          if(cg1 || cg2 || cg3){
            // Kalau false salah satu, hanya boleh return with ref
            allowShipto = true;
          } else {
            if(this.form.so_types != 'with_so_reference' && this.form.isDetail != 1 && !this.form.isEdit ){
              // msg = "Allow Return False for "
              // Old msg = "Cannot using invoice shipto for return without reff !<br>" + msg,
              // CR-2600123 - Ubah wording saja.
              msg = "Customer group "
              if(!cg1 && cg1 != null){
                // msg += "<br>Customer Group 1 " + resSelected[0].cust_group_1.code
                msg += resSelected[0].cust_group_1.code + " "
              }
              if(!cg2 && cg2 != null){
                // msg += "<br>Customer Group 2 " + resSelected[0].cust_group_2.code
                msg += resSelected[0].cust_group_2.code + " "
              }
              if(!cg3 && cg3 != null){
                // msg += "<br>Customer Group 3 " + resSelected[0].cust_group_3.code
                msg += resSelected[0].cust_group_3.code + " "
              }

              msg += "not allowed return without reference."
    
              this.$vs.notify({
                title: "Error",
                text: msg,
                color: "danger",
                iconPack: "feather",
                icon: "icon-x-circle",
              });
              return;
            }
          }
        }
        return allowShipto;
      }
    }
  },
  mounted() {
    console.log("form", this.form)
    if (this.form.isEdit || this.form.isDetail) {
      this.$refs.searchCustomerInvoice.setCode(
        this.form.customer_invoice_data.invoice_code
      );
      this.isDisabled = true;
      if (this.form.so_types != "without_so_reference") {
        this.sales_name = this.form.customer_invoice_data.sales_order_data == null ? this.form.customer_invoice_data.sales_id_name : this.form.customer_invoice_data.sales_order_data.SalesPersonalCodeExternal + " - " + this.form.customer_invoice_data.sales_order_data.SalesPersonalName;
      }      
    }
    if (this.returnTypeStr == "1") {
      this.isFullReturn = true;
    }
  },
  watch: {
    "form.so_types": {
      handler: function (so_types) {
        console.log("form.so_types", this.form.so_types)
        console.log("so_types", so_types)
        if (so_types == "without_so_reference" && this.form.customer_invoice_data != null) { 
          this.setNullInvoiceData(true);
        }
      },
    },
    returnTypeStr: {
      handler: function (so_type_str) {
        console.log("so_type_str", so_type_str)
        let full_return
        if (so_type_str == "1") {
          this.isFullReturn = true;
          full_return = true;
        } else {
          this.isFullReturn = false;
          full_return = false;
        }
        console.log("this.isFullReturn, full_return", this.isFullReturn, full_return)

        
        let invCode = (this.form.customer_invoice_data.invoice_id != null && this.form.customer_invoice_data.invoice.Code != undefined) ? this.form.customer_invoice_data.invoice.Code : null;
        let compCode = this.$refs.searchCustomerInvoice.getCode();
        console.log("Before recall search invoice", invCode, this.form.customer_invoice_data)
        console.log("compCode", compCode)
        
        if ( !(this.form.isEdit || this.form.isDetail == 1) ) {
          this.setNullInvoiceData(false);
          invCode = (this.form.customer_invoice_data.invoice_id != null && this.form.customer_invoice_data.invoice.Code != undefined) ? this.form.customer_invoice_data.invoice.Code : null;

          if (invCode != null && (compCode == null || compCode == '')) {
            console.log("Recall search invoice", invCode)
            this.$refs.searchCustomerInvoice.setCode(invCode);
            this.$refs.searchCustomerInvoice.findByCode(invCode, full_return);
          }
          if (compCode != null && invCode == null){
            console.log("Recall search invoice", compCode);
            this.$refs.searchCustomerInvoice.findByCode(compCode, full_return);
          }
        }
      },
    },
  }
};
</script>
